<template>
  <div id="bot-detection-page">
    <page-header-component icon="bi bi-robot" title="Bot Detection" />
    <transition name="block">
      <div class="row mb-4" v-if="mounted">
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Jumlah Akun Bot</h6>
              <bar-chart-component
                :dataset="barchart_akun.series"
                :y-label="barchart_akun.yLabel"
                barchart_id="media-cetak-barchart"
              />
            </div>
          </div>
        </div>
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Tren Akun Bot</h6>
              <line-chart-component
                :series="lincechart_akun"
                height="400"
                el="linechart-tren-akun-bot"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="block">
      <div class="row mb-4" v-if="mounted">
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Postingan Akun Bot</h6>
              <bar-chart-component
                :dataset="barchart_posting.series"
                :y-label="barchart_posting.yLabel"
                barchart_id="media-cetak-barchart"
              />
            </div>
          </div>
        </div>
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Tren Postingan Bot</h6>
              <line-chart-component
                :series="lincechart_posting"
                height="400"
                el="linechart-tren-posting-bot"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="block">
      <div class="row mb-4" v-if="mounted">
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Jumlah Berita Hoax</h6>
              <bar-chart-component
                :dataset="barchart_akun.series"
                :y-label="barchart_akun.yLabel"
                barchart_id="media-cetak-barchart"
              />
            </div>
          </div>
        </div>
        <div class="col-6 px-gap">
          <div class="card shade card-default m-b-10" style="height: 100%">
            <div class="card-body">
              <h6>Tren Berita Hoax</h6>
              <line-chart-component :series="lincechart_akun" height="400" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import bar_chart_highchart from "@/views/components/chart/bar_chart_highchart.vue";
import line_chart from "@/views/components/chart/line_chart.vue";

export default {
  name: "BotDetection",
  title: "Analytics Bot Detection | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "bar-chart-component": bar_chart_highchart,
    "line-chart-component": line_chart,
  },
  data() {
    return {
      mounted: false,
      barchart_akun: {
        series: [
          ["<25%", 100],
          ["26% - 50%", 150],
          ["51% - 75%", 120],
          ["76% - 100%", 60],
        ],
        yLabel: "Total Akun",
      },
      barchart_posting: {
        series: [
          ["<25%", 100],
          ["26% - 50%", 150],
          ["51% - 75%", 120],
          ["76% - 100%", 60],
        ],
        yLabel: "Total Posting",
      },
      lincechart_akun: {
        x: [
          "03 Sep 2021",
          "04 Sep 2021",
          "05 Sep 2021",
          "06 Sep 2021",
          "07 Sep 2021",
          "08 Sep 2021",
          "09 Sep 2021",
        ],
        y: [
          { name: "<25%", data: [17, 5, 6, 16, 7, 0, 0] },
          { name: "26% - 50%", data: [6, 2, 0, 0, 0, 2, 0] },
          { name: "51% - 75%", data: [2, 1, 1, 0, 1, 0, 0] },
          { name: "76% - 100%", data: [0, 1, 0, 0, 0, 0, 0] },
        ],
      },
      lincechart_posting: {
        x: [
          "03 Sep 2021",
          "04 Sep 2021",
          "05 Sep 2021",
          "06 Sep 2021",
          "07 Sep 2021",
          "08 Sep 2021",
          "09 Sep 2021",
        ],
        y: [
          { name: "<25%", data: [17, 5, 6, 16, 7, 0, 0] },
          { name: "26% - 50%", data: [6, 2, 0, 0, 0, 2, 0] },
          { name: "51% - 75%", data: [2, 1, 1, 0, 1, 0, 0] },
          { name: "76% - 100%", data: [0, 1, 0, 0, 0, 0, 0] },
        ],
      },
    };
  },
  mounted: function () {
    this.mounted = true;
  },
};
</script>